module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/cars-7babbe284f51a4829e40de67a401ec5e.svg";